const checkAllowPurchase = (orderTotal: number, vendorMinimumOrder: number) => {
  return orderTotal > 0 && Number(orderTotal) >= vendorMinimumOrder
}

export default checkAllowPurchase
